// extracted by mini-css-extract-plugin
export var searchIcon = "styles-module--searchIcon--wEmhe";
export var searchSvg = "styles-module--searchSvg--M7T-r";